<template>
	<confirm-button
		v-bind="$attrs"
		small
		:callback="submitDelete"
	>
		<translate>
			Remove
		</translate>
	</confirm-button>
</template>

<script>
import {
	displayError,
	inform,
} from 'laravel-front-library';
import {
	axios,
} from '../../services/axios-service';
import {
	debounce,
} from 'lodash';

export default {
	name: 'ConfirmDeleteButton',

	props: {
		url: {
			type: String,
			required: true,
		},
		id: {
			type: Number,
			required: true,
		}
	},

	methods: {
		/**
		 * Submit delete request with the given url and id
		 *
		 * @returns {void}
		 */
		submitDelete () {
			axios.delete(this.url + `?id=${this.id}`).then(() => {
				inform(this.$gettext('Page deleted'));
				debounce(() => {
					window.location.reload();
				}, 1000)();
			}).catch((error) => {
				displayError(this.$gettext('Page could not be deleted'));
				window.captureException(error);
			});
		}
	},
};
</script>
